export default {"src":"kbwebsite/assets/_next/static/media/download_google_play.092d96ac.svg","height":42,"width":144};